export type Brand = {
  key: string;
  title: string;
  subtitle: string;
  description: string;
  ogTitle: string;
  logo: string;
  favicon: string;
  ogImage: string;
  defaultLocale: string;
};

const brands: Record<string, Brand> = {
  dossm: {
    key: 'dossm',
    title: 'Dossm Hospitality AI Video Platform',
    subtitle: 'Hospitality AI Video Platform',
    description: 'DOSSM · 一站式 AI 视频创作平台，邀您一起体验智能创作。',
    ogTitle: 'DOSSM · Hospitality AI Video Platform',
    logo: '/brands/dossm/logo.png',
    favicon: '/brands/dossm/favicon.ico',
    ogImage: '/brands/dossm/wx-logo.png',
    defaultLocale: 'en-US',
  },
  wintour: {
    key: 'wintour',
    title: 'Dossm Hospitality AI Video Platform',
    subtitle: 'Hospitality AI Video Platform',
    description: 'Wintour · 一站式 AI 视频创作平台，邀您一起体验智能创作。',
    ogTitle: 'DOSSM · Hospitality AI Video Platform',
    logo: '/brands/wintour/logo.png',
    favicon: '/brands/wintour/favicon.ico',
    ogImage: '/brands/wintour/wx-logo.png',
    defaultLocale: 'zh-CN',
  },
};

const BRAND = process.env.BRAND || 'wintour';

export const currentBrand: Brand = brands[BRAND] ?? brands.wintour;
